var Component = require("!../../../../node_modules/.11.1.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/.11.1.4@vue-loader/lib/selector?type=script&index=0!./option-group.vue"),
  /* template */
  require("!!../../../../node_modules/.11.1.4@vue-loader/lib/template-compiler?{\"id\":\"data-v-1307f5ac\"}!../../../../node_modules/.11.1.4@vue-loader/lib/selector?type=template&index=0!./option-group.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/packages/select/src/option-group.vue
// module id = 207
// module chunks = 0